import React from 'react';
import './mapi.css';

// Asset imports
import mapiTop from '../assets/mapi/Mapi_top.png';
import background from '../assets/mapi/background.png';
import phone1_1 from '../assets/mapi/Phone1_1.png';
import phone1_2 from '../assets/mapi/Phone1_2.png';
import phone2_1 from '../assets/mapi/Phone2_1.png';
import phone2_2 from '../assets/mapi/Phone2_2.png';
import phone2_3 from '../assets/mapi/Phone2_3.png';
import phone3_1 from '../assets/mapi/Phone3_1.png';
import phone3_2 from '../assets/mapi/Phone3_2.png';
import phone4_1 from '../assets/mapi/Phone4_1.png';
import phone4_2 from '../assets/mapi/Phone4_2.png';
import phone4_3 from '../assets/mapi/Phone4_3.png';

import Footer from './Footer';

function Mapi() {
  return (
    <div className="App">
      <main className="App-main">
        {/* Top Section - Full Width */}
        <section className="mapi-top-section">
          <img src={mapiTop} alt="Mapi Top" className="mapi-top-image" />
          <div className="mapi-top-overlay">
            <h1 className="mapi-title-main">MAPI</h1>
            <p className="mapi-subtitle">Mobile-app</p>
          </div>
        </section>

        {/* About Section - 100px height */}
        <section className="mapi-about-section">
          <div className="mapi-about-container">
            <h2 className="mapi-about-title">ABOUT PROJECT</h2>
            <p className="mapi-about-text selectable">
              Crowdsourced mapping solution addressing the need for up-to-date street-level imagery.
              Created full product experience that motivates users to capture and share geographic
              data through rewards, social features, and intuitive mobile interface.
            </p>
          </div>
        </section>

        {/* Background Section with Phones */}
        <section className="mapi-phones-section">
          <img src={background} alt="Background" className="mapi-phones-bg" />
          <div className="mapi-phones-container">
            {/* Row 1 - 2 phones centered */}
            <div className="mapi-phone-row mapi-row-1">
              <div className="mapi-phone-item">
                <img src={phone1_1} alt="Phone 1-1" />
                <div className="mapi-tooltip mapi-tooltip-1-top">
                  Motivational system with progress visualization to increase user engagement in geodata collection
                </div>
              </div>
              <div className="mapi-phone-item">
                <img src={phone1_2} alt="Phone 1-2" />
                <div className="mapi-tooltip mapi-tooltip-1-bottom">
                  Frictionless sign-up experience with social login integration and brand-consistent visual identity
                </div>
              </div>
            </div>

            {/* Row 2 - 3 phones centered */}
            <div className="mapi-phone-row mapi-row-2">
              <div className="mapi-phone-item">
                <img src={phone2_1} alt="Phone 2-1" />
              </div>
              <div className="mapi-phone-item">
                <img src={phone2_2} alt="Phone 2-2" />
                <div className="mapi-tooltip mapi-tooltip-2-top">
                  Scalable mobile interface with real-time map rendering, progressive disclosure onboarding
                </div>
              </div>
              <div className="mapi-phone-item">
                <img src={phone2_3} alt="Phone 2-3" />
                <div className="mapi-tooltip mapi-tooltip-2-bottom">
                  Scan management system with rewards and batch upload with point-based rewards
                </div>
              </div>
            </div>

            {/* Row 3 - 2 phones centered */}
            <div className="mapi-phone-row mapi-row-3">
              <div className="mapi-phone-item">
                <img src={phone3_1} alt="Phone 3-1" />
                <div className="mapi-tooltip mapi-tooltip-3-top">
                  User dashboard combining progress visualization with accessible settings controls
                </div>
              </div>
              <div className="mapi-phone-item">
                <img src={phone3_2} alt="Phone 3-2" />
                <div className="mapi-tooltip mapi-tooltip-3-bottom">
                  Viral loop mechanics with seamless sharing and transparent reward tracking
                </div>
              </div>
            </div>

            {/* Row 4 - 4_1 and 4_2 stacked on left, 4_3 on right */}
            <div className="mapi-phone-row mapi-row-4">
              <div className="mapi-phone-stacked-vertical">
                <img src={phone4_1} alt="Phone 4-1" />
                <img src={phone4_2} alt="Phone 4-2" className="mapi-phone-stacked-bottom" />
              </div>
              <div className="mapi-phone-item">
                <img src={phone4_3} alt="Phone 4-3" />
                <div className="mapi-tooltip mapi-tooltip-4-top">
                  Real-time camera interface with progress tracking and visual guides for data capture
                </div>
                <div className="mapi-tooltip mapi-tooltip-4-bottom">
                  Session summary with route visualization, detailed metrics, and file upload workflow
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Mapi;
